export const DESKTOP_MAX_SIZE = "375px";
